import type { LineItemI } from 'declarations/interfaces/lineItems';
import type { RooftopExistsI } from 'declarations/interfaces/rooftopExists';

import { get } from './api';

export const getRepairOrderExistsApi = async (
  roofTopId: string,
  roNumber: string
): Promise<RooftopExistsI> => {
  const response = await get<RooftopExistsI>(`/repair-order/${roofTopId}/${roNumber}`);

  return response.data;
};

export const getLineItemsApi = async (
  roofTopId: string,
  roNumber: string
): Promise<LineItemI[]> => {
  const response = await get<LineItemI[]>(`/repair-order/${roofTopId}/${roNumber}/lineItems`);

  return response.data;
};
